/* eslint-disable max-len */
import React, { useContext } from 'react';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter
} from '@jutro/components';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './AuthenticatedFlowInformationalPopup.metadata.json5';
import messages from './AuthenticatedFlowInformationalPopup.messages';
import styles from './AuthenticatedFlowInformationalPopup.module.scss';

function AuthenticatedFlowInformationalPopup(props) {
    const {
        isOpen,
        onResolve,
        onReject
    } = props;
    const translator = useContext(TranslatorContext);

    return (
        <ModalNext
            isOpen={isOpen}
            className={styles.body}
            contentLayout={{
                component: 'grid',
                componentProps: {
                    rows: ['auto', '1fr', 'auto'],
                    vgap: 'none',
                    className: styles.modalLayout
                }
            }}
        >
            <ModalHeader
                title={translator(messages.authenticatedFlowInformationalPopupTitle)}
            />
            <ModalBody
                id="authenticatedFlowInformationalPopupBody"
                contentLayout={{
                    component: 'grid'
                }}
            >
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    classNameMap={styles}
                />
            </ModalBody>
            <ModalFooter>
                <div className={styles.okButtonWrapper}>
                    <Button onClick={onResolve} type="secondary" fullWidth>
                        {translator(messages.authenticatedFlowInformationalPopupOkButton)}
                    </Button>
                </div>
            </ModalFooter>
        </ModalNext>
    );
}

export default AuthenticatedFlowInformationalPopup;
